import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 发票抬头
 */
class HeaderType extends UltMeta {
    COMPANY = new Meta(1, "企业");
    OTHER = new Meta(2, "个人或事业单位");
}
export const HEADER_TYPE = new HeaderType();
/**
 * 发票类型
 */
class InvoiceType extends UltMeta {
    REGULAR = new Meta(1, "普通发票");
    VAT = new Meta(2, "增值税专用发票");
}
export const INVOICE_TYPE = new InvoiceType();
